<template>
  <div class="jobelement">
    <div
      :class="'jobelement__body jobelement__body--' + this.job.frontendstatus"
    >
      <dl
        :class="
          'jobelement__header jobelement__header--mailbox jobelement__header--' +
          this.job.frontendstatus
        "
      >
        <dt class="jobelement__name">
          <div>{{ job.name }}</div>
          <i class="icofont-tick-mark"></i>
          <i class="icofont-ui-laoding icofont-spin"></i>
          <i class="icofont-exclamation-tringle"></i>
          <i class="icofont-question-circle"></i>
        </dt>
        <dd class="jobelement__namesubline">
          <ul class="jobelement__namesubline-list">
            <li
              class="jobelement__namesubline-listitem jobelement__namesubline-info"
            >
              <span
                class="job-success-text"
                v-if="job.frontendstatus === 'success'"
                v-html="job.jobInfo"
              ></span>
              <span
                class="price-net-text"
                v-if="job.frontendstatus === 'success'"
                >&nbsp; (netto)</span
              >
              <span
                class="job-info-text"
                v-if="job.frontendstatus === 'error'"
                v-html="job.jobError"
              ></span>
              <span
                class="job-info-text"
                v-if="
                  job.frontendstatus !== 'success' &&
                  job.frontendstatus !== 'error'
                "
                v-html="job.jobInfo"
              ></span>
            </li>
            <li
              class="jobelement__namesubline-listitem jobelement__namesubline-listitem--mobileactions"
            >
              <ul class="jobelement__mobileaction-list">
                <li
                  class="jobelement__mobileaction-listitem jobelement__mobileaction-listitem--inspect"
                  @click="previewJob(job)"
                >
                  <i class="icofont-ui-search"></i>
                </li>
                <li
                  class="jobelement__mobileaction-listitem jobelement__mobileaction-listitem--inspect-success"
                  @click="previewJob(job)"
                >
                  <i class="icofont-ui-search"></i>
                </li>
                <li
                  class="jobelement__mobileaction-listitem jobelement__mobileaction-listitem--basket"
                  @click="addToCart(job)"
                ></li>
                <transition name="refreshfade">
                  <li
                    v-show="refreshButtonVisible"
                    class="jobelement__mobileaction-listitem jobelement__mobileaction-listitem--refresh"
                    @click="reloadJob(job)"
                  ></li>
                </transition>
                <li
                  class="jobelement__mobileaction-listitem jobelement__mobileaction-listitem--delete"
                  @click="removeJob(job)"
                >
                  <i class="icofont-trash"></i>
                </li>
              </ul>
            </li>
          </ul>
        </dd>
      </dl>
      <dl
        :class="
          'jobelement__control jobelement__control--edit-mobile jobelement__control--' +
          this.job.frontendstatus
        "
      >
        <dd class="jobelement__namesubline">
          <ul class="jobelement__mobileaction-list">
            <li
              class="jobelement__mobileaction-listitem jobelement__mobileaction-listitem--edit"
              @click="editJob(job)"
            >
              <i class="icofont-ui-edit"></i>
            </li>
          </ul>
        </dd>
      </dl>
      <dl class="jobelement__control jobelement__control--mailbox">
        <dt class="jobelement__control-header">
          {{ this.config.lang["job.control.pages"] }}
        </dt>
        <dd class="jobelement__control-value">
          {{ job.logicalPages }}
        </dd>
      </dl>
      <dl class="jobelement__control jobelement__control--mailbox">
        <dt class="jobelement__control-header">
          {{ this.config.lang["job.control.recipients"] }}
        </dt>
        <dd class="jobelement__control-value">
          {{ job.recipients }}
        </dd>
      </dl>
      <dl class="jobelement__control jobelement__control--mailbox">
        <dt class="jobelement__control-header">
          {{ this.config.lang["job.control.print"] }}
        </dt>
        <dd class="jobelement__control-value">
          <span
            :class="
              'jobelement__control-value-colortype jobelement__control-value-colortype--' +
              this.job.colortypemodifier
            "
          ></span>
          <span
            :class="
              'jobelement__control-value-printtype jobelement__control-value-printtype--' +
              this.job.printtypemodifier
            "
          ></span>
        </dd>
      </dl>
      <dl class="jobelement__control jobelement__control--mailbox">
        <dt class="jobelement__control-header">
          {{ this.config.lang["job.control.registered"] }}
        </dt>
        <dd class="jobelement__control-value">
          <span
            :class="
              'jobelement__control-value-shipmenttype jobelement__control-value-shipmenttype--' +
              this.job.shipmenttypemodifier
            "
          ></span>
          <span class="jobelement__control-value-registered"></span>
        </dd>
      </dl>
      <dl
        class="jobelement__control jobelement__control--upload-time jobelement__control--mailbox jobelement__control--mailboxid"
      >
        <dt class="jobelement__control-header">
          {{ this.config.lang["job.control.upload"] }}
        </dt>
        <dd class="jobelement__control-value">
          <span class="text--content-bold">{{ job.uploadDate }},</span>
          {{ job.uploadTime }} Uhr
        </dd>
      </dl>
      <ul
        class="jobelement__deskaction-list jobelement__deskaction-list--mailbox"
      >
        <li
          class="jobelement__deskaction-listitem jobelement__deskaction-listitem--edit"
          @click="editJob(job)"
        >
          <i class="icofont-ui-edit"></i>
        </li>
        <li
          class="jobelement__deskaction-listitem jobelement__deskaction-listitem--inspect"
          @click="previewJob(job)"
        >
          <i class="icofont-ui-search"></i>
        </li>
        <li
          class="jobelement__deskaction-listitem jobelement__deskaction-listitem--inspect-success"
          @click="previewJob(job)"
        >
          <i class="icofont-ui-search"></i>
        </li>
        <li
          class="jobelement__deskaction-listitem jobelement__deskaction-listitem--basket"
          @click="addToCart(job)"
        ></li>
        <transition name="refreshfade">
          <li
            v-show="refreshButtonVisible"
            class="jobelement__deskaction-listitem jobelement__deskaction-listitem--refresh"
            @click="reloadJob(job)"
          ></li>
        </transition>
        <li
          class="jobelement__deskaction-listitem jobelement__deskaction-listitem--delete"
          @click="removeJob(job)"
        >
          <i class="icofont-trash"></i>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: "MailboxJob",
  props: {
    pid: {
      type: String,
      default: () => ""
    },
    job: {
      type: Object,
      default: () => ({})
    },
    configdata: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      refreshButtonVisible: false
    };
  },
  computed: {
    config: function () {
      return configdata;
    }
  },
  methods: {
    removeJob(job) {
      this.$emit("remove-job", job.pid);
    },
    addToCart(job) {
      this.$emit("add-job-to-cart", job);
    },
    editJob(job) {
      this.$emit("edit-job", job);
    },
    previewJob(job) {
      this.$emit("preview-job", job);
    },
    reloadJob(job) {
      this.$emit("reload-job", job);
    }
  },
  created() {
    if (this.job.frontendstatus === "in-process") {
      setTimeout(() => (this.refreshButtonVisible = true), 11000);
    } else {
      this.refreshButtonVisible = false;
    }
  },
  updated() {
    if (this.job.frontendstatus === "in-process") {
      setTimeout(() => (this.refreshButtonVisible = true), 11000);
    } else {
      this.refreshButtonVisible = false;
    }
  }
};
</script>
